import React from 'react'

const Stack = React.forwardRef(
  (
    { children, className, direction = 'column', spacing = 0, wrap = true },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={`yns-stack flex ${
          direction === 'row' ? 'flex-row' : 'flex-col'
        } ${
          direction === 'row'
            ? `${wrap ? 'flex-wrap' : 'flex-nowrap'} gap-${spacing}`
            : `gap-${spacing}`
        } ${direction === 'row' ? `items-center` : ``} ${className || ''}`}
      >
        {children}
      </div>
    )
  },
)

Stack.displayName = 'Stack'

export default Stack
